import { forwardRef, SVGProps, useId } from "react";

export const WalletGradient = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function WalletGradient(props, ref) {
    // hack to make sure the id is unique - svg uses a gradient through a url, when a parent of at least one such svg has display: none, the gradient is not rendered on all other svgs
    const id = useId();

    const computedId = `wallet-gradient-linear-${id}`;

    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M18.75 15V16.5625C18.75 17.4244 18.0487 18.125 17.1875 18.125H3.75C2.37125 18.125 1.25 17.0037 1.25 15.625C1.25 15.625 1.25 5.00938 1.25 5C1.25 3.62125 2.37125 2.5 3.75 2.5H15.3125C15.8306 2.5 16.25 2.92 16.25 3.4375C16.25 3.955 15.8306 4.375 15.3125 4.375H3.75C3.40563 4.375 3.125 4.655 3.125 5C3.125 5.345 3.40563 5.625 3.75 5.625H17.1875C18.0487 5.625 18.75 6.32562 18.75 7.1875V8.75H15.625C13.9019 8.75 12.5 10.1519 12.5 11.875C12.5 13.5981 13.9019 15 15.625 15H18.75Z"
          fill={`url(#${computedId})`}
        />
        <path
          d="M19 10V13.75H15.875C14.8394 13.75 14 12.9106 14 11.875C14 10.8394 14.8394 10 15.875 10H19Z"
          fill="#EC9023"
        />
        <defs>
          <linearGradient
            id={computedId}
            x1="10.0021"
            y1="18.1248"
            x2="10.0021"
            y2="2.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF6533" />
            <stop offset="1" stopColor="#FCBA1B" />
          </linearGradient>
        </defs>
      </svg>
    );
  },
);
